palette = ['#0570b0', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#045a8d', '#023858'];
var hideStates = {};
var regionPalette = {};

var pinExists = drupalSettings.pinsComputedStorage;
if ( pinExists !== undefined ) {
  var dataPins = drupalSettings.pinsComputedStorage.map(function(val, i, arr) {
    return {latLng: [parseFloat(val.latt), parseFloat(val.long)], name: val.tip, status: 'pin'};
  });
}

var colorRegions = drupalSettings.regionsComputedStorage;
var legendList = drupalSettings.legendComputedStorage;

function renderColorMap(stateColors) {
  var jvectorMap = jQuery("#regionmap");
  if( jvectorMap.length ) {
    var map = new jvm.Map({
      map: 'us_lcc',
      container: jQuery('#regionmap'),
      backgroundColor: 'transparent',
      onRegionClick: showLocation,
      zoomOnScroll: false,
      series: {
        regions: [{
          attribute: 'fill',
          values: stateColors
        }]
      },
      regionStyle: {
        initial: {
          fill: "#0071bc"
        }
      }
    });
    return map;
  }
}

// the map i want to manipulate
function renderWhdMap() {
  var jvectorWhdMap = jQuery("#whdmap");
  if( jvectorWhdMap.length ) {
    var whdmap = new jvm.Map({
      map: 'us_lcc',
      container: jQuery('#whdmap'),
      backgroundColor: 'transparent',
      onRegionClick: showWhdLocation,
      zoomOnScroll: false,
      series: {
        regions: [{
          attribute: 'fill',
          values: colorRegions
        }]
      },
      regionStyle:{
        initial: {
            fill: '#0071bc',
            "fill-opacity": 1,
            stroke: '#fff',
            "stroke-width": 1,
            "stroke-opacity": 1
        },
        hover: {
            "fill-opacity": .7,
            cursor: 'pointer'
        },
        selected: {
            fill: 'yellow'
        },
        selectedHover: {

        }
      },
      markerStyle: {
        initial: {
            fill: '#FFFFFF',
            stroke: '#262C34',
            "stroke-width": 5,
            "stroke-opacity": .8,
            r: 6
        },
        hover: {
          stroke: '#262C34',
          cursor: 'pointer',
          "stroke-width": 4,
          "stroke-opacity": .5
        }
      },
      markers: dataPins
    });

    var dataHide = jQuery(".paragraph--type--whd-map").attr("data-hide");
    if ( dataHide !== undefined ) {
      var hideList = jQuery(".paragraph--type--whd-map").attr("data-hide").split(" ");
      hideList.forEach(function (element) {
        var hiddenState = jQuery('[data-code="' + element + '"]');
        hiddenState[0].style.display = 'none';
      });
    }

    if ( legendList !== undefined ) {
      createLegend(legendList);
    }

    return whdmap;
  }
}


stateDict = {
  AL: "Alabama",
  AK: "Alaska",
  AS: "American Samoa",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CNMI: "CNMI",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "District of Columbia",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  VI: "Virgin Islands",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming"
};



function showLocation(event, label) {
  let regionalOffice = "/agencies/vets/about/regionaloffices";
  switch (label.toLowerCase())
  {
    case "al":window.location.href = regionalOffice + "/atlanta#al"; break;
    case "ak":window.location.href = regionalOffice + "/sanfrancisco#ak"; break;
    case "az":window.location.href = regionalOffice + "/sanfrancisco#az"; break;
    case "ar":window.location.href = regionalOffice + "/dallas#ar"; break;
    case "ca":window.location.href = regionalOffice + "/sanfrancisco#ca"; break;
    case "co":window.location.href = regionalOffice + "/dallas#co"; break;
    case "ct":window.location.href = regionalOffice + "/boston#ct"; break;
    case "dc":window.location.href = regionalOffice + "/philadelphia#dc"; break;
    case "de":window.location.href = regionalOffice + "/philadelphia#de"; break;
    case "fl":window.location.href = regionalOffice + "/atlanta#fl"; break;
    case "ga":window.location.href = regionalOffice + "/atlanta#ga"; break;
    case "gu":window.location.href = regionalOffice + "/sanfrancisco#guhi"; break;
    case "hi":window.location.href = regionalOffice + "/sanfrancisco#guhi"; break;
    case "id":window.location.href = regionalOffice + "/sanfrancisco#id"; break;
    case "il":window.location.href = regionalOffice + "/chicago#il"; break;
    case "in":window.location.href = regionalOffice + "/chicago#in"; break;
    case "ia":window.location.href = regionalOffice + "/chicago#ia"; break;
    case "ks":window.location.href = regionalOffice + "/chicago#ks"; break;
    case "ky":window.location.href = regionalOffice + "/atlanta#ky"; break;
    case "la":window.location.href = regionalOffice + "/dallas#la"; break;
    case "me":window.location.href = regionalOffice + "/boston#me"; break;
    case "md":window.location.href = regionalOffice + "/philadelphia#md"; break;
    case "ma":window.location.href = regionalOffice + "/boston#ma"; break;
    case "mi":window.location.href = regionalOffice + "/chicago#mi"; break;
    case "mn":window.location.href = regionalOffice + "/chicago#mn"; break;
    case "ms":window.location.href = regionalOffice + "/atlanta#ms"; break;
    case "mo":window.location.href = regionalOffice + "/chicago#mo"; break;
    case "mt":window.location.href = regionalOffice + "/dallas#mt"; break;
    case "ne":window.location.href = regionalOffice + "/chicago#ne"; break;
    case "nv":window.location.href = regionalOffice + "/sanfrancisco#nv"; break;
    case "nh":window.location.href = regionalOffice + "/boston#nh"; break;
    case "nj":window.location.href = regionalOffice + "/boston#nj"; break;
    case "nm":window.location.href = regionalOffice + "/dallas#nm"; break;
    case "ny":window.location.href = regionalOffice + "/boston#ny"; break;
    case "nc":window.location.href = regionalOffice + "/atlanta#nc"; break;
    case "nd":window.location.href = regionalOffice + "/dallas#nd"; break;
    case "oh":window.location.href = regionalOffice + "/chicago#oh"; break;
    case "ok":window.location.href = regionalOffice + "/dallas#ok"; break;
    case "or":window.location.href = regionalOffice + "/sanfrancisco#or"; break;
    case "pa":window.location.href = regionalOffice + "/philadelphia#pa"; break;
    case "pr":window.location.href = regionalOffice + "/boston#prvi"; break;
    case "ri":window.location.href = regionalOffice + "/boston#ri"; break;
    case "sc":window.location.href = regionalOffice + "/atlanta#sc"; break;
    case "sd":window.location.href = regionalOffice + "/dallas#sd"; break;
    case "tn":window.location.href = regionalOffice + "/atlanta#tn"; break;
    case "tx":window.location.href = regionalOffice + "/dallas#tx"; break;
    case "ut":window.location.href = regionalOffice + "/dallas#ut"; break;
    case "vt":window.location.href = regionalOffice + "/boston#vt"; break;
    case "va":window.location.href = regionalOffice + "/philadelphia#va"; break;
    case "vi":window.location.href = regionalOffice + "/boston#prvi"; break;
    case "wa":window.location.href = regionalOffice + "/sanfrancisco#wa"; break;
    case "wv":window.location.href = regionalOffice + "/philadelphia#wv"; break;
    case "wi":window.location.href = regionalOffice + "/chicago#wi"; break;
    case "wy":window.location.href = regionalOffice + "/dallas#wy"; break;
  }
}

function showWhdLocation(event, label) {
  if (label != '') {
    var stateNoSpaces = stateDict[label.toUpperCase()].split(' ').join('');
    if (document.getElementById(stateNoSpaces) !== null) {
      window.location.hash = stateNoSpaces;
    } else if (document.getElementById(label.toLowerCase()) !== null) {
      window.location.hash = label.toLowerCase();
    } else if (document.getElementById(label.toUpperCase()) !== null) {
      window.location.hash = label.toUpperCase();
    } else {
      window.location.hash = stateNoSpaces;
    }
  } else {
    window.location.hash = '';
  }
}


function generateLegacyColors(stateData) {
  var colors = {},
    key;
  var regions = [];
  var i = 0;
  stateData.forEach(function(element) {
    // Found new region
    if (regions.indexOf(element.Type) === -1) {
      regions.push(element.Type);
      regionPalette[element.Type] = palette[i];
      i++;
    }
    // State is one we want to show
    if (!(element.State in hideStates)) {
      colors[element.State] = regionPalette[element.Type];
    } else {
      colors[element.State] = "none";
    }
  });
  return colors;
}

function setupRegions(stateData) {
  var regions = [];
  var regionPalette = {};
  var i = 0;
  stateData.forEach(function(element) {
    if (regions.indexOf(element.Type) === -1) {
      regions.push(element.Type);
      regionPalette[element.Type] = palette[i];
      i++;
    }
  });
  return regionPalette;
}

function createStateDropdown() {
  var selectBox = "";
  var label = '<label class="usa-label" for="selectState">Select a State:</label>';
  selectBox += label;
  var selectStart = '<select id="selectState" class="usa-select" name="selectState" aria-label="Select State" onchange="showLocation(event, this.options[this.selectedIndex].value)">';
  var defaultValue = '<option value="">-- Select a State --</option>';
  selectBox += selectStart + defaultValue;

  var options = "";
  for (var state in stateDict) {
    if (!Object.prototype.hasOwnProperty.call(hideStates, state)) {
      options += '<option value="' + state + '">' + stateDict[state] + '</option>';
    }
  }
  selectBox += options + "</select>";
  document.getElementById("map-select").innerHTML = selectBox;
}

function createLegend(regionPalette) {

  var regionCount = Object.keys(regionPalette).length;
  if (regionCount > 0) {
    var legend = "<h2>Legend</h2><ul>";
    document.getElementById("map-legend").innerHTML = legend;
    for (var color in regionPalette) {
      if (typeof regionPalette[color] !== "function") {
        legend += "<li>";
        legend += "<div class='box' style='background:" + regionPalette[color] + ";'>";
        legend += "</div>";
        legend += color + "</li>";
      }
    }
    document.getElementById("map-legend").innerHTML = "</ul>" + legend;
  } else {
    document.getElementById("map-legend").innerHTML = "";
  }
}

function renderMinwageMap(stateData) {
  var jvectorMap = jQuery('#minwagemap');
  if( jvectorMap.length ) {
    var map = new jvm.Map({
      map: 'us_lcc',
      container: jQuery('#minwagemap'),
      backgroundColor: 'transparent',
      onRegionClick: showWhdLocation,
      zoomOnScroll: false,
      series: {
        regions: [{
          attribute: 'fill'
        }]
      },
      regionStyle: {
        initial: {
          fill: '#0071bc'
        }
      },
      onRegionTipShow: function (e, tip, code) {
        var showState = jQuery.grep(vStateData, function (element, index) {
          return element.State == code;
        });
        if (showState.length > 0) {
          if (showState[0].Wage != '') {
            tip.html(tip.html() + ' - ' + showState[0].Wage + '/hr');
          } else {
            tip.html(tip.html() + ' - N/A');
          }
        }
      }
    });
    map.series.regions[0].setValues(generateLegacyColors(vStateData));
    createLegend(regionPalette);
    createStateDropdown();
    return map;
  }
}
